import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthContext } from "../hooks/useAuthContext";
import LoadingSpinner from "./LoadingSpinner"

// Protected Route Component
export const ProtectedRoute = ({ children, requireAuth = true, adminOnly = false }) => {
  const { user } = useAuthContext();
  const [isAdmin, setIsAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAdminStatus = async () => {
      if (user) {
        try {
          const idTokenResult = await user.getIdTokenResult();
          setIsAdmin(idTokenResult.claims?.admin || false);
        } catch (error) {
          console.error("Error checking admin status:", error);
          setIsAdmin(false);
        }
      }
      setIsLoading(false);
    };
    checkAdminStatus();
  }, [user]);

  // If still loading, return null or a loading component
  if (isLoading) {
    return <LoadingSpinner/>; // You might want to replace this with a proper loading spinner
  }

  // Admin-only route
  if (adminOnly) {
    if (!user) return <Navigate to="/login" replace />;
    if (!isAdmin) return <Navigate to="/" replace />;
    return children;
  }

  // Routes that require authentication
  if (requireAuth) {
    if (!user) return <Navigate to="/login" replace />;
    return children;
  }

  // Routes for unauthenticated users (like login/signup)
  if (!requireAuth) {
    if (user) return <Navigate to="/" replace />;
    return children;
  }

  // Fallback
  return children;
};